import { Select, MenuItem, TextField, Button, Paper } from "@mui/material";
import { FC, useState, useEffect } from "react";

export type FilterFunction = "matchCPV" | "matchContractingBodies" | "matchTitle" | "matchCountryAndContractingBodies" | "matchDescriptionOrTitle" | "matchDescriptionOrTitleFullWord" | "matchContractors";

const allFunctions = ["matchCPV", "matchContractingBodies", "matchTitle", "matchCountryAndContractingBodies", "matchDescriptionOrTitle", "matchDescriptionOrTitleFullWord" , "matchContractors"] as FilterFunction[];

// TODO: check if 2 or 3 letter codes are used
export type CountryCode = "" | "AT" | "BE" | "BG" | "HR" | "CY" | "CZ" | "DK" | "EE" | "FI" | "FR" | "DE" | "GR" | "HU" | "IE" | "IT" | "LV" | "LT" | "LU" | "MT" | "NL" | "PL" | "PT" | "RO" | "SK" | "SI" | "ES" | "SE";

const allCodes = ["", "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"] as CountryCode[]


export type TEDFilterType = {
    filterFunction: FilterFunction,
    country: CountryCode,
    parameter: string[],
    filterId: string,
    _id: any
}

export interface TEDFilterComponentProps {
    TEDFilterIndex: number,
    TEDFilter: TEDFilterType,
    TEDFilterUpdated: (filter: TEDFilterType, index: number) => void,
    deleteFilter: (index: number) => void
}

export const TEDFilterComponent: FC<TEDFilterComponentProps> = ({ TEDFilterIndex, TEDFilter, TEDFilterUpdated, deleteFilter }) => {

    let [filterFunction, setFilterFunction] = useState(TEDFilter.filterFunction);
    let [country, setCountry] = useState(TEDFilter.country?TEDFilter.country:"" as CountryCode);
    let [parameter, setParameter] = useState(TEDFilter.parameter);
    let [overallIndex, setOverallIndex] = useState(TEDFilterIndex);
    let [filterId, setFilterId] = useState(TEDFilter.filterId);
    let [updated, setUpdated] = useState(false);

    function handleFilterFunctionChanged(event){
        setUpdated(true);
        setFilterFunction(event.target.value as FilterFunction);
    }

    function handleCountryChanged(event){
        setUpdated(true);
        setCountry(event.target.value);
    }

    function handleParameterChanged(index, value){
        setUpdated(true);
        let newParameter = [... parameter];
        newParameter[index] = value;
        setParameter(newParameter);
    }

    function handleDeleteParameter(index: number){
        setUpdated(true);
        let newParameter = [... parameter];
        newParameter.splice(index, 1);
        setParameter(newParameter);
    }


    function handleAddParameterClicked(){
        setUpdated(true);
        const newArray = [... parameter, ""];
        setParameter(newArray);
    }

    function handleUpdateClicked(){
        updateServer();
    }

    function handleFilterIdChanged(event){
        setUpdated(true);
        setFilterId(Number(event.target.value));
    }

    function updateServer(){
        const newFilter = {
            filterFunction: filterFunction,
            country: country,
            parameter: parameter,
            filterId: filterId,
            _id: null
        }
        TEDFilterUpdated(newFilter, overallIndex);
        setUpdated(false);
    }


    return (
        <> 
            <Paper elevation={6} sx={{ padding: 4 }}>
                <Select value={filterFunction} onChange={handleFilterFunctionChanged}>
                {
                    allFunctions.map(matchingFunction => {
                        return <MenuItem value={matchingFunction}>{matchingFunction}</MenuItem>
                    })
                }
                </Select>
                <Select value={country} onChange={handleCountryChanged}>
                    {
                        allCodes.map(code => {
                            return <MenuItem value={code}>{code}</MenuItem>
                        })
                    }
                </Select>
                <TextField value={filterId} onChange={handleFilterIdChanged}></TextField>
                <br/>
                {
                    parameter.map((currentParameter, index) => {
                        return(
                            <>
                                <TextField value={currentParameter} onChange={(event) => { handleParameterChanged(index, event.target.value) }}/>
                                <Button color="error" onClick={ () => {handleDeleteParameter(index) }}>Delete</Button>
                                <br/>
                            </>
                        )
                    })
                }
                <Button onClick={handleAddParameterClicked}>Add</Button>
                {
                    updated?<><br/><Button onClick={handleUpdateClicked} sx={{ width: 1/1}}>Update</Button><br/></>:null
                }
                <Button color="error" onClick={() => { deleteFilter(overallIndex) }}>Delete</Button>
            </Paper>            
        </>
    )
}
